import { DatePicker } from 'antd'
import dayjs, { type Dayjs } from 'dayjs'
import { MAX_DASHBOARD_WINDOW_DAYS, dashboardPresets } from './dateRange'

const { RangePicker } = DatePicker

interface DashboardRangePickerProps {
  value: [Dayjs, Dayjs]
  onChange: (range: [Dayjs, Dayjs]) => void
}

function disabledDate(current: Dayjs, info: { from?: Dayjs }): boolean {
  if (current.isAfter(dayjs().endOf('day'))) return true
  if (!info.from) return false
  return Math.abs(current.diff(info.from, 'day')) >= MAX_DASHBOARD_WINDOW_DAYS
}

/** How far back every dashboard on the page reports. */
export function DashboardRangePicker({
  value,
  onChange,
}: DashboardRangePickerProps) {
  return (
    <RangePicker
      value={value}
      // Clearing it would leave the dashboards with no window to report on.
      allowClear={false}
      presets={dashboardPresets()}
      disabledDate={disabledDate}
      onChange={(dates) => {
        const [start, end] = dates ?? []
        if (start && end) onChange([start.startOf('day'), end.endOf('day')])
      }}
      style={{ width: 250 }}
    />
  )
}
